<template>
  <div>
    <v-dialog v-model="dialog" scrollable width="500">
      <v-card>
        <v-card-title class="grey lighten-2">
          เพิ่มข้อความแบบมีตัวเลือก
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <AddButtongroup :form="form" />
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="CloseQuickReply"> ปิด </v-btn>
          <v-btn color="primary" text @click="SendQuickReply"> เพิ่ม </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card
      id="keyboard"
      class="pa-3 d-flex align-center"
      flat
      tile
      color="grey lighten-3 py-0"
    >
      <v-expand-x-transition>
        <div v-show="KeyboardMenu">
          <div class="d-flex" style="margin-top: 0px; margin-right: 3px">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  :disabled="
                    !Editing ||
                    (LastQuestion ? LastQuestion.type === 'quickReply' : false)
                  "
                  v-show="
                    questioninfo
                      ? questioninfo.questionType !== 'fail' &&
                        questioninfo.questionType !== 'end'
                      : true
                  "
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="dialog = true">
                  <v-list-item-title>ข้อความแบบมีตัวเลือก</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <VideoInput
              @success="$emit('bottom')"
              :Editing="Editing"
              :questioninfo="questioninfo"
              :LastQuestion="LastQuestion"
              @sendvideo="SendVideo"
            />
            <Picture
              @success="$emit('bottom')"
              :Editing="Editing"
              :questioninfo="questioninfo"
              :LastQuestion="LastQuestion"
              @sendimage="SendImage"
            />
          </div>
        </div>
      </v-expand-x-transition>
      <v-btn
        :disabled="
          !Editing ||
          (LastQuestion ? LastQuestion.type === 'quickReply' : false)
        "
        class="ml-n2"
        icon
        small
        @click="$store.commit('KeyboardMenuToggle')"
        v-if="SmallSize"
      >
        <v-icon>{{
          KeyboardMenu ? "keyboard_arrow_left" : "keyboard_arrow_right"
        }}</v-icon>
      </v-btn>
      <v-textarea
        v-model="message"
        :disabled="
          !Editing ||
          (LastQuestion ? LastQuestion.type === 'quickReply' : false)
        "
        color="primary"
        id="textarea"
        ref="keyboard"
        rounded
        :persistent-hint="
          LastQuestion ? LastQuestion.type === 'quickReply' : false
        "
        :hint="
          LastQuestion
            ? LastQuestion.type === 'quickReply'
              ? '`กรุณาลบ ข้อความแบบมีตัวเลือก ก่อน เพื่อเพิ่มข้อความต่อไป`'
              : ''
            : ''
        "
        placeholder="Aa"
        no-resize
        rows="1"
        :style="{
          height: `${scrollHeight}px`,
          'margin-bottom': '4px',
          'padding-top': '9px',
          'background-color':
            !Editing ||
            (LastQuestion ? LastQuestion.type === 'quickReply' : false)
              ? '#80808075'
              : 'white',
        }"
        @keydown="MessageNewLine"
        @focus="(focus = true), MenuOff()"
        @blur="focus = false"
      ></v-textarea>
      <v-btn
        icon
        :color="focus ? 'primary' : undefined"
        :disabled="
          !Editing ||
          (LastQuestion ? LastQuestion.type === 'quickReply' : false)
        "
        @click="SendMessage"
      >
        <v-icon>mdi-send</v-icon>
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import Picture from "./Picture";
import VideoInput from "./VideoInput.vue";
import AddButtongroup from "../Conversation/QuickReply/AddButtongroup";
export default {
  props: ["questioninfo", "Editing"],
  components: { Picture, AddButtongroup, VideoInput },
  data: () => ({
    row: 1,
    message: "",
    dialog: false,
    focus: null,
    scrollHeight: 45,
    form: {
      type: "quickReply",
      text: "",
      buttons: [
        {
          type: "text",
          text: "",
          errorLabel: false,
          errorLabelMsg: "",
        },
      ],
    },
  }),
  computed: {
    SmallSize() {
      const { xs, sm } = this.$vuetify.breakpoint;
      return xs || sm ? true : false;
    },
    KeyboardMenu() {
      return this.$store.state.keyboardmenu;
    },
    LastQuestion() {
      return this.QuestionList[this.QuestionList.length - 1];
    },
    QuestionList() {
      return this.questioninfo ? this.questioninfo.questions : [];
    },
  },
  mounted() {
    // this.KeyboardInput();
    // this.FocusTextarea();
  },
  methods: {
    MenuOff() {
      const { xs, sm } = this.$vuetify.breakpoint;
      if (xs || sm) {
        this.$store.commit("KeyboardMenuOff");
      }
    },
    FocusTextarea() {
      setTimeout(function () {
        this.$refs.keyboard.$el.focus();
      }, 0);
    },
    KeyboardInput() {
      var observe;
      let vm = this;
      if (window.attachEvent) {
        observe = function (element, event, handler) {
          element.attachEvent("on" + event, handler);
        };
      } else {
        observe = function (element, event, handler) {
          element.addEventListener(event, handler, false);
        };
      }
      var text = document.getElementById("textarea");
      // var text = this.$refs.keyboard.$el;
      function resize() {
        if (text.scrollHeight <= 112) {
          text.style.height = "auto";
          text.style.height = text.scrollHeight - 12 + "px";
          vm.scrollHeight = text.scrollHeight - 12 + 25;
        } else {
          text.style.height = "auto";
          text.style.height = 96 - 12 + "px";
          vm.scrollHeight = 96 - 12 + 25;
        }
      }
      /* 0-timeout to get the already changed text */
      function delayedResize() {
        window.setTimeout(resize, 0);
      }
      observe(text, "change", resize);
      observe(text, "cut", delayedResize);
      observe(text, "paste", delayedResize);
      observe(text, "drop", delayedResize);
      observe(text, "keydown", delayedResize);
      text.focus();
      text.select();
      resize();
    },
    SendMessage() {
      if (this.message.trim().length > 0) {
        this.QuestionList.push({
          type: "text",
          text: this.message.trim(),
        });
        this.message = "";
        this.scrollHeight = 45;
        document.getElementById("textarea").style.height = "32px";
        // this.FocusTextarea();
        this.$emit("bottom");
      }
    },
    SendImage(url) {
      this.QuestionList.push({
        type: "image",
        url: url,
      });
      this.message = "";
      this.scrollHeight = 45;
      document.getElementById("textarea").style.height = "32px";
      // this.FocusTextarea();
      this.$emit("bottom");
    },
    SendVideo(url) {
      this.QuestionList.push({
        type: "video",
        url: url,
      });
      this.message = "";
      this.scrollHeight = 45;
      document.getElementById("textarea").style.height = "32px";
      // this.FocusTextarea();
      this.$emit("bottom");
    },
    SendQuickReply() {
      this.form.text = this.form.text.trim();
      if (this.$refs.form.validate() && this.form.text) {
        let nodup = [];
        this.form.buttons.map((q) => {
          if (q.errorLabel) {
            nodup.push(q);
          }
        });
        this.form.buttons.map((q) => {
          q.text = q.text.trim();
          if (!q.text) {
            nodup.push(q);
          }
        });
        if (nodup.length < 1) {
          this.QuestionList.push(JSON.parse(JSON.stringify(this.form)));
          this.form = {
            type: "quickReply",
            text: "",
            buttons: [
              {
                type: "text",
                text: "",
                errorLabel: false,
                errorLabelMsg: "",
              },
            ],
          };
          this.$refs.form.resetValidation();
          this.dialog = false;
          this.message = "";
          this.scrollHeight = 45;
          document.getElementById("textarea").style.height = "32px";
          // this.FocusTextarea();
          this.$emit("bottom");
        }
      }
    },
    CloseQuickReply() {
      this.dialog = false;
      this.form = {
        type: "quickReply",
        text: "",
        buttons: [
          {
            type: "text",
            text: "",
            errorLabel: false,
            errorLabelMsg: "",
          },
        ],
      };
      this.$refs.form.resetValidation();
    },
    MessageNewLine(e) {
      this.emoji = false;
      if (e.keyCode === 13) {
        if (!e.shiftKey) {
          e.preventDefault();
          this.SendMessage();
        }
      }
    },
  },
};
</script>
<style scoped>
/* #keyboard >>> .v-text-field__slot {
  margin-top: 0px !important;
}
#keyboard >>> textarea {
  line-height: normal;
}
#keyboard >>> .v-input__control {
  height: 0px;
  margin-bottom: 0px;
}
#keyboard >>> .v-input__slot {
  margin-bottom: 0px;
} */
</style>
